/* eslint-disable max-lines */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getProjectStatuses } from '@services/admin.service';
import Checkbox from '@library/Checkbox/Checkbox';
import style from '@css/theme.style.json';

import './status-select.styl';

function CustomLabel({ status }) {
  const { id, attributes: { name } } = status;
  
  return (
    <span className="status-select__checkbox__label">
      {name}
      <span 
        className="status-select__checkbox__label__status" 
        style={{ backgroundColor: style.color.project[id] }}
      />
    </span>
  )
}

function StatusSelect({
  filters, setFilters, availableFeatures, activeStatus, 
}) {
  function updateSelectionArray(v) {
    if (filters.status.includes(v)) {
      setFilters({ 
        ...filters, 
        status: filters.status.filter(o => o !== v), 
      });
    } else {
      setFilters({ 
        ...filters, 
        status: [...filters.status, v], 
      });
    }
  }

  const { data: projectStatusesData } = useQuery({
    queryKey: ['projectStatuses'],
    queryFn: getProjectStatuses,
  });

  const availableIds = useMemo(() => (
    availableFeatures.flatMap(f => f?.properties?.[`status_${activeStatus}`])
  ), [availableFeatures, activeStatus]);

  if (!projectStatusesData) return null;
    
  return (
    <div className="status-select">
      {projectStatusesData.find(vc => vc.id === 1).attributes.show_in_filter !== false && (
      <Checkbox 
        name={projectStatusesData.find(s => s.id === 1).id}
        className={
              'status-select__checkbox'
              + `${!availableIds.includes(1) ? ' status-select__checkbox--disabled' : ''}`
            }
        label={(<CustomLabel status={projectStatusesData.find(s => s.id === 1)} />)}
        checked={filters.status.includes('1')}
        onChange={(e, c, v) => updateSelectionArray(v)}
      />
      )}
      {projectStatusesData.find(vc => vc.id === 2).attributes.show_in_filter !== false && (
      <Checkbox 
        name={projectStatusesData.find(s => s.id === 2).id}
        className={
              'status-select__checkbox'
              + `${!availableIds.includes(2) ? ' status-select__checkbox--disabled' : ''}`
            }
        label={(<CustomLabel status={projectStatusesData.find(s => s.id === 2)} />)}
        checked={filters.status.includes('2')}
        onChange={(e, c, v) => updateSelectionArray(v)}
      />
      )}
      {projectStatusesData.find(vc => vc.id === 3).attributes.show_in_filter !== false && (
      <Checkbox 
        name={projectStatusesData.find(s => s.id === 3).id}
        className={
              'status-select__checkbox'
              + `${!availableIds.includes(3) ? ' status-select__checkbox--disabled' : ''}`
            }
        label={(<CustomLabel status={projectStatusesData.find(s => s.id === 3)} />)}
        checked={filters.status.includes('3')}
        onChange={(e, c, v) => updateSelectionArray(v)}
      />
      )}
      {projectStatusesData.find(vc => vc.id === 4).attributes.show_in_filter !== false && (
      <Checkbox 
        name={projectStatusesData.find(s => s.id === 4).id}
        className={
              'status-select__checkbox'
              + `${!availableIds.includes(4) ? ' status-select__checkbox--disabled' : ''}`
            }
        label={(<CustomLabel status={projectStatusesData.find(s => s.id === 4)} />)}
        checked={filters.status.includes('4')}
        onChange={(e, c, v) => updateSelectionArray(v)}
      />
      )}
      {projectStatusesData.find(vc => vc.id === 6).attributes.show_in_filter !== false && (
      <Checkbox 
        name={projectStatusesData.find(s => s.id === 6).id}
        className={
              'status-select__checkbox'
              + `${!availableIds.includes(6) ? ' status-select__checkbox--disabled' : ''}`
            }
        label={(<CustomLabel status={projectStatusesData.find(s => s.id === 6)} />)}
        checked={filters.status.includes('6')}
        onChange={(e, c, v) => updateSelectionArray(v)}
      />
      )}
    </div>
  )
}

export default StatusSelect;